import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTimeTypesByProductName = (
    backend: string,
    token: string,
    productName: number,
) => {
    return fetch(
        `${getApiUrl(backend)}timeTypes/by_name/${productName}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getTimeTypesByProductName;